import React, { useEffect, useMemo, useRef } from 'react';
import numeral from 'numeral';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import Highcharts from 'highcharts';
import solidGauge from 'highcharts/modules/solid-gauge';
import piramid from 'highcharts/modules/funnel';
import highchartsMore from 'highcharts/highcharts-more.js';
import { ToastContainer, toast as showToast } from 'react-toastify';
import { animateScroll as scroll } from 'react-scroll';
import { handleNewEventMixPanel, checkIfIsTradeView as checkIfIsTradeViewHelper } from '@utils/helpers';
import Loading from '@components/Loading/Loading';
import { TranslatorProvider } from 'react-translate';
import { translationsPT, translationsEN, translationsES } from '@src/translate';
import { useUser } from '@utils/contexts';
import MyRouter from '@src/router/router';
import { useDetectAdBlock } from 'adblock-detect-react';

import { CHANGE_LANGUAGE } from '@redux/translates/types';
import {
  FETCH_DOMAIN,
  USER_DATA_DECODED,
  GET_CURRENT_USER,
  AUTHENTICATE_BUSINESS,
  BUSINESS_DATA_DECODED,
} from '@redux/auth/types';

import '@fortawesome/fontawesome-pro/css/all.css';
import 'react-toastify/dist/ReactToastify.css';

import {
  getSubDomain,
  setTrackableCockie,
  getTrackableCockie,
  setBusinessID,
  getBusinessID,
} from '@utils/auth';

import * as S from './styles';
import { Warning } from '@components/Warning';

highchartsMore(Highcharts);
piramid(Highcharts);
solidGauge(Highcharts);

function App(props) {
  const { gtag } = window;
  const {
    dispatch,
    translatorReducer: { language },
    authenticationReducer: {
      dataUser,
      businessId,
      businessTokenData,
      businessTokenData: { permitted_group },
    },
    toastReducer: { toast },
    loadingReducer: { isLoading },
    history,
    location,
    match: { params },
  } = props;
  const { logout, subDomain, decodedBusinessToken, businessToken, invalidTenant } = useUser();
  const isTradeView = useRef(false);

  const adBlockDetected = useDetectAdBlock();

  const localBusinessId = getBusinessID();

  function getTranslation() {
    if (language === 'pt-BR') {
      return translationsPT;
    }
    if (['es-es', 'es-ES'].includes(language)) {
      return translationsES;
    }
    return translationsEN;
  }

  function scrollTop() {
    scroll.scrollToTop();
  }

  function getPathWithIndex(index) {
    return history.location.pathname.split('/')[index];
  }

  function redirectTo(route) {
    history.push(route);
  }

  function checkIfHaveGroupPermission() {
    const isRoot = getPathWithIndex(1) === 'root';
    const { module, group } = params;

    if (permitted_group && isRoot) {
      return redirectTo(
        `/${permitted_group}/${getPathWithIndex(2)}/
                ${!module ? getPathWithIndex(3) : module}
                /${!group ? getPathWithIndex(4) : group}`
      );
    }
  }

  function checkIfIsTradeView() {
    if (
      checkIfIsTradeViewHelper()
    ) {
      isTradeView.current = true;
      return true;
    }

    isTradeView.current = false;
    return false;
  }

  // ERM-369
  // function redirectToGlobal(decoded) {
  //   let customDecoded = null;

  //   if (isTradeView.current) {
  //     history.push('/root/Trade/Dashboard');
  //   } else if (decoded.bgd_capabilities) {
  //     customDecoded = JSON.parse(decoded.bgd_capabilities);
  //     if (
  //       decoded.permitted_group &&
  //       customDecoded.some((item) => item.name === 'APPROVAL') &&
  //       customDecoded.find((item) => item.name === 'APPROVAL').is_main_capability
  //     ) {
  //       redirectTo(`/${decoded.permitted_group}/Actions/Approvals/New`);
  //     } else if (
  //       !decoded.permitted_group &&
  //       customDecoded.some((item) => item.name === 'APPROVAL') &&
  //       customDecoded.find((item) => item.name === 'APPROVAL').is_main_capability
  //     ) {
  //       redirectTo('/root/Actions/Approvals/New');
  //     } else if (decoded.permitted_group) {
  //       redirectTo(`/${decoded.permitted_group}/Dashboard`);
  //     } else {
  //       redirectTo('/root/Dashboard');
  //     }
  //   } else if (decoded.bgd_capabilities_v2) {
  //     if (decoded.bgd_capabilities_v2.includes('TRADE_ADS_INDUSTRY')) {
  //       redirectTo('/root/TradeAds');
  //     } else if (decoded.permitted_group) {
  //       redirectTo(`/${decoded.permitted_group}/Dashboard`);
  //     } else {
  //       redirectTo('/root/Dashboard');
  //     }
  //   }
  // }

  function decodeBusinessToken() {
    let decoded = decodedBusinessToken;

    if (decoded && decoded.bgd_capabilities) {
      decoded = {
        ...decoded,
        bgd_capabilities: JSON.parse(decoded.bgd_capabilities),
      };
    } else if (decoded && decoded.bgd_capabilities_v2) {
      const obj = decoded.bgd_capabilities_v2.split(' ').reduce((acc, cur) => {
        const temp = cur.split(':');
        acc[temp[0]] = temp[1];
        return acc;
      }, {});

      decoded = {
        ...decoded,
        bgd_capabilities_v2: obj,
      };
    } else {
      logout();
    }

    dispatch({
      type: BUSINESS_DATA_DECODED.SUCCESS,
      decoded,
    });
  }

  useEffect(() => {
    if (subDomain) {
      checkIfIsTradeView();
      setBusinessID(subDomain.id);
      dispatch({
        type: FETCH_DOMAIN.REQUEST,
        version: '1.2',
        subDomain: subDomain.sub_domain || getSubDomain(),
      });

      if (localBusinessId && localBusinessId !== subDomain.id) {
        dispatch({
          type: AUTHENTICATE_BUSINESS.REQUEST,
          version: '1.2',
        });
      }
    }
  }, [subDomain]);

  useEffect(() => {
    if (decodedBusinessToken) {
      const decoded = decodedBusinessToken;
      dispatch({
        type: USER_DATA_DECODED.SUCCESS,
        decoded,
      });

      decodeBusinessToken();

      if (!decoded.email || decoded.email.indexOf('bornlogic') > 0) {
        setTrackableCockie(false);
      } else {
        setTrackableCockie(true);
      }
      if (subDomain && subDomain.id !== '') {
        handleNewEventMixPanel('send_login_web', 'view', props.authenticationReducer, props.match);
      }

      // Dispatch adicionado para colocar o businessToken no redux
      dispatch({
        type: AUTHENTICATE_BUSINESS.SUCCESS,
        token: businessToken,
      });

      // redirectToGlobal(decoded);
    }
  }, [decodedBusinessToken]);

  useEffect(() => {
    if (Object.keys(businessTokenData).length !== 0) {
      checkIfHaveGroupPermission();
      dispatch({
        type: GET_CURRENT_USER.REQUEST,
        version: '1.2',
        id: businessTokenData.unique_name,
        search:
          'fields=user_id,role,status,language,user_name,user_last_name,avatar_url,email,permitted_groups',
      });
      scrollTop();
    }
  }, [businessTokenData]);

  useEffect(() => {
    if (
      location.pathname &&
      history.action === 'PUSH' &&
      typeof gtag === 'function' &&
      getTrackableCockie() === 'true'
    ) {
      gtag('config', 'UA-128083991-1', {
        page_location: window.location.href,
        page_path: window.location.hash.substring(1),
        user_id: dataUser.user_id,
        business_id: businessId,
      });
    }

    if (location.pathname) {
      scrollTop();
    }
  }, [location]);

  useEffect(() => {
    // Update utilizado para exibir o toast na aplicação
    if (toast && toast.message) {
      showToast(toast.message, { type: toast.type });
    }
  }, [toast]);

  useEffect(() => {
    // Seta o language caso o usuário esteja na tela de login e não possua preferencia ainda buscada do usuário.
    if (!language) {
      const language = navigator.language === 'pt-BR' ? 'pt-BR' : 'en-US';
      dispatch({
        type: CHANGE_LANGUAGE.SUCCESS,
        language,
      });
      numeral.locale(language);
    }
  }, [language]);

  useEffect(() => {
    if (dataUser.language) {
      dispatch({
        type: CHANGE_LANGUAGE.SUCCESS,
        language: dataUser.language,
      });
      numeral.locale(dataUser.language);
    }
  }, [dataUser]);

  const adBlockAlert = useMemo(() => {
    if (adBlockDetected) {
      return (
        <Warning icon="ban" infinite>
          Diversas funcionalidades do GD são afetadas pelo ADBLOCK, recomendamos desligar.
        </Warning>
      );
    }

    return;
  }, [adBlockDetected]);

  const invalidTenantAlert = useMemo(() => {
    if (invalidTenant) {
      return <Warning icon="ban">Tenant não autorizado</Warning>;
    }

    return;
  }, [invalidTenant]);

  return (
    <TranslatorProvider translations={getTranslation()}>
      {invalidTenantAlert}
      {adBlockAlert}
      <S.AppWrapper isTradeView={isTradeView.current}>
        <MyRouter />
      </S.AppWrapper>
      <Loading isLoading={isLoading} />
      <S.ToastWrapper>
        <ToastContainer />
      </S.ToastWrapper>
    </TranslatorProvider>
  );
}

function mapStateToProps({
  translatorReducer,
  authenticationReducer,
  loadingReducer,
  toastReducer,
  businessReducer,
  genericReducer,
}) {
  return {
    translatorReducer,
    authenticationReducer,
    loadingReducer,
    toastReducer,
    businessReducer,
    genericReducer,
  };
}

export default withRouter(connect(mapStateToProps)(App));
